import Axios from "axios";
import {
  AddOfficePostRequest,
  AddUserOfficePostRequest,
  AddUserOfficePostResponse,
  GetOfficePostsByUserIdResponse,
  GetOfficePostsResponse,
  GetUserInfoByUserIdResponse,
  GetUserOfficePostsResponse,
} from "../models/officePosts.model";
import { ApiResultModel } from "../models/common.model";
import { ApiBaseUrl, OfficePosts, SecurityBaseUrl } from "../config/config";

export const GetOfficePosts = async (data: {
  officePostId: number | null;
}): Promise<GetOfficePostsResponse[]> => {
  return await Axios.post<ApiResultModel<GetOfficePostsResponse[]>>(
    // SERVIES_URL
    ApiBaseUrl + OfficePosts + "/GetOfficePosts",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const AddOfficePost = async (
  data: AddOfficePostRequest
): Promise<{ id: number }> => {
  return await Axios.post<ApiResultModel<{ id: number }>>(
    // SERVIES_URL
    ApiBaseUrl + OfficePosts + "/AddOfficePost",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const DeleteOfficePost = async (data: {
  officePostId: number;
}): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    // SERVIES_URL
    ApiBaseUrl + OfficePosts + "/DeleteOfficePost",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const EditOfficePost = async (
  data: AddOfficePostRequest
): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    // SERVIES_URL
    ApiBaseUrl + OfficePosts + "/EditOfficePost",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const GetUserOfficePosts = async (data: {
  id: number;
}): Promise<GetUserOfficePostsResponse[]> => {
  return await Axios.post<ApiResultModel<GetUserOfficePostsResponse[]>>(
    // SERVIES_URL
    ApiBaseUrl + OfficePosts + "/GetUserOfficePosts",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const AddUserOfficePost = async (
  data: AddUserOfficePostRequest
): Promise<AddUserOfficePostResponse[]> => {
  return await Axios.post<ApiResultModel<AddUserOfficePostResponse[]>>(
    // SERVIES_URL
    ApiBaseUrl + OfficePosts + "/AddUserOfficePost",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const DeleteUserOfficePost = async (data: {
  userId: number;
  userOfficePostId: number;
}): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    // SERVIES_URL
    ApiBaseUrl + OfficePosts + "/DeleteUserOfficePost",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const GetUserInfoByUserId = async (data: {
  id: number;
}): Promise<GetUserInfoByUserIdResponse> => {
  return await Axios.post<ApiResultModel<GetUserInfoByUserIdResponse>>(
    // SERVIES_URL
    ApiBaseUrl + SecurityBaseUrl + "/GetUserInfoByUserId",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const GetOfficePostsByUserId = async (data: {
  id: number;
}): Promise<GetOfficePostsByUserIdResponse[]> => {
  return await Axios.post<ApiResultModel<GetOfficePostsByUserIdResponse[]>>(
    // SERVIES_URL
    ApiBaseUrl + OfficePosts + "/GetTreeUserOfficePosts",
    data
  ).then((result) => {
    return result.data.data;
  });
};
